import { render, staticRenderFns } from "./BaseButtonAsset.vue?vue&type=template&id=28201742&scoped=true"
import script from "./BaseButtonAsset.vue?vue&type=script&lang=js"
export * from "./BaseButtonAsset.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonAsset.vue?vue&type=style&index=0&id=28201742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28201742",
  null
  
)

export default component.exports